"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.center = exports.width = exports.radius = void 0;
var radius = 100 / (2 * Math.PI);
exports.radius = radius;
var width = 42;
exports.width = width;
var center = {
  x: width / 2,
  y: width / 2
};
exports.center = center;
//# sourceMappingURL=constants.js.map